// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__17fd1","active":"Breadcrumbs_active__ZR30C","past":"Breadcrumbs_past__eDtUv","future":"Breadcrumbs_future__191D2","svg":"Breadcrumbs_svg__1ymfI"};